import { useState } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { clearSelectedCertificate, resetCertificateData } from '../features/employer-certificate/employer-certificate.slice';
import { EmployerCertificateList } from './employer-certificate/employer-certificate-list.component';
import { EmployerCertificateOrderForm } from './employer-certificate/employer-certificate-order-form.component';
import './employer-certificate-content.component.scss';

export const EmployerCertificateContent: React.FC = () => {
    const [showOrderForm, setShowOrderForm] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch<any>();
    const [searchParams] = useSearchParams();
    const certificateId = searchParams.get('certificateId');
    const isEmployerCertificateDraft = searchParams.get('isEmployerCertificateDraft') === 'true';

    const showForm = showOrderForm || !!certificateId;

    const handleOrderCertificate = () => {
        dispatch(clearSelectedCertificate());
        dispatch(resetCertificateData());
        setShowOrderForm(true);
    };

    const handleBackToList = () => {
        setShowOrderForm(false);
        const params = new URLSearchParams(location.search);
        params.delete('certificateId');
        params.delete('isEmployerCertificateDraft');
        const newSearch = params.toString();
        navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ''}`, { replace: true });
    };

    return (
        <div className="employer-certificate-content">
            {!showForm ? (
                <EmployerCertificateList onOrderCertificate={handleOrderCertificate} />
            ) : (
                <EmployerCertificateOrderForm
                    onCancel={handleBackToList}
                    onSubmitSuccess={handleBackToList}
                    editCertificateId={certificateId ? Number(certificateId) : undefined}
                    isEmployerCertificateDraft={isEmployerCertificateDraft}
                />
            )}
        </div>
    );
};
